<template>
    <div>
        <p> <label class="text-info margin-top margin-bottom">Your review</label></p>
        <p><input type="number" name="age" id="age" v-model="age"></p>
        <button @click="handleSubmit" type="button">Hi</button>
    </div>
</template>

<script>
export default {
  name: 'review',
  data(){
    return{
    errors: [],
    age: null
    }
  },
  methods:{
       handleSubmit: function(){
        // Send data to the server or update your stores and such.
        alert("Your question is submitted.");
        this.age = '10';
       
      }
  } 
}  
</script>


// WEBPACK FOOTER //
// src/components/review.vue